import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    AddToCartContainer as SourceAddToCartContainer,
    mapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceComponent/AddToCart/AddToCart.container';
import getStore from 'Util/Store';

export {
    mapDispatchToProps
};

/** @namespace Elganso/Component/AddToCart/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    device: state.ConfigReducer.device
});

/** @namespace Elganso/Component/AddToCart/Container */
export class AddToCartContainer extends SourceAddToCartContainer {
    static propTypes = {
        ...this.propTypes,
        isProductCard: PropTypes.bool,
        addingToCart: PropTypes.func
    };

    static defaultProps = {
        ...this.defaultProps,
        isProductCard: false,
        addingToCart: null
    };

    containerProps() {
        const {
            unselectedOptions,
            product,
            product: {
                sku
            },
            device,
            isProductCard,
            addingToCart
        } = this.props;

        return {
            ...super.containerProps(),
            preorder: this.isPreorder(),
            unselectedOptions,
            threshold_qty: getStore().getState().ConfigReducer.threshold_qty,
            product,
            sku,
            device,
            isProductCard,
            addingToCart
        };
    }

    isPreorder() {
        const {
            product: {
                preorder
            }
        } = this.props;

        if (preorder) {
            return preorder;
        }

        return 0;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToCartContainer);
